import { createState } from "@hookstate/core";
import { carType } from "constant";

const APP_CONSTANTS_STATE = createState({
  getCarsCounter: 0,
  warningBatteryLevel: 25,
  criticalBatteryLevel: 10,
  paceStatusNormal: 1,
  paceStatusWarning: 2,
  paceStatusCritical: 3,
  notInUseCarType: 0,
  fleetCarType: 1,
  marshalCarType: 2,
  specialNeedCarType: 3,
  beveragesCarType: 4,
  outsidePerimeterCarType: 5,
  notCommunicatingCarEnabled: 2,
  notCommunicatingCarDisabled: 0,
});

const SIDENAV_GLOBAL_STATE = createState({
  subNavDataState: "DASHBOARD",
  sideDrawerState: false,
  sideNavClassAdder: "",
  sideDrawerActiveTabState: 0,
  forMapNavbar: "",
  sideNavMapState: false,
});
const LANGUAGE_GLOBAL_STATE = createState({
  languageState: "",
  currencyState: "$",
  decimalState: ",",
  thousandState: ",",
  distanceState: "Yards",
  selectedLang: "enUS",
});

const COMMON_COMPONENTS_STATES = createState({
  AllShow: false,
  carList: [],
  showTagCarOnFleet: false,
  showTagCarState2: false,
  showTagCarsStatenew2: false,
  showTagCarsState: false,
  showTagCarsFromMapState: false,
  showMessageWindowState: false,
  findCars: false,
  showPopupBoxState: 0,
  detectScreenState: "",
  showTagCarsStatenew: false,
  localSiteTimeState: "",
});
const CAR_NUMBER_MESSAGE = createState({
  setCarNumber: 0,
  carMessageSelector: [],
  carsForMessagesGetter: [],
  msgBtnState: { state: false, activeNo: "", gpsiCarId: "" },
  fromMsgPage: false,
  carsGpsSelectorData: [],
  carsForMessagesGetter2: [],
  carMessageDataHandler: false,
  carsGpsSelectorData2: [],
  carsDataMessages: [],
  carMessageID: null,
});

const MESSAGE_COUNT = createState({
  MessageNumber: 0,
  MessageSoundRingerDetector: 0,
  messageIdForDelete: null,
});
const TAGGINGCAR = createState({
  tagCar: false,
});

const MANIFEST_COUNT = createState({
  ManifestCount: 0,
});
const CHATMESSAGE = createState({
  MessageCount: false,
});

let deactivateAllBtn = localStorage.getItem("deactivateAllBtn") === "true";

const MAP_GLOBAL_STATES = createState({
  currentClickedTab: "",
  displayLocation: localStorage.getItem("displayLocation") ? localStorage.getItem("displayLocation") : false,
  carPopupClickEvent: null,
  closingPopup: false,
  mapTypeHandler: "satellite",
  prevMapTypeValue: "satellite",
  carPathState: false,
  mapsDataGlobalState: null,
  mapDataGlobalState: null,
  showSpeedCar: [],
  showTaggedCarArrayNew: [],
  showDistanceCar: [],
  showMaxHolesCar: [],
  showCarType: [],
  showDistanceSpeed: [],
  carSectionStatus: false,
  siteSetupSection: true,
  showMessageBoxForSingleCar: false,
  showMessageBoxForSingleCarFleet: false,
  getSingleCarData: [],
  getSingleCarDataFleet: [],
  tagCarNumber: [],
  tagCarNumberFleet: [],
  mapSideNavTabState: "",
  taggedCarsSaverGlobalState: [],
  taggedCarsSaverGlobalStateMaintainer: [],
  taggedCarsSaverGlobalStateInput: [],
  taggedCarsContainerGlobalState: [],
  taggedCarsDisplayerGlobalState: false,
  messageFindCar: false,
  paceFindCar: false,
  TagActive: true,
  showClickToDriveWindow: false,
  enableClickToDriveFeature: false,
  addTableDataUpdated: false,
  addDiscardSavePopup: false,
  addTableData: [],
  showAllCars: "showCars",
  showCheckedCars: [],
  hoverWindowState: false,
  clickWindowState: false,
  clickWindowStateCarNumber: null,
  clientXOnClick: 0,
  clientYOnClick: 0,
  getSelectedCars: [],
  getSelectedCarsMapState: [],
  getSelectedCarsMapState2: [],
  getSelectedCarsState: [],
  mapCarsSelectAll: true,
  fleetCarsGlobalState: true,
  specialCarsGlobalState: true,
  memberCarsGlobalState: false,
  marshalCarsGlobalState: true,
  bewrageCarsGlobalState: true,
  notInUseCarsGlobalState: true,
  outsidePerimeterGlobalState: true,
  carsNotCommunicatingGlobalState: true,
  getCheckedCars: [
    { carName: "fleetCars", carType: carType.normal, isChecked: true },
    { carName: "marshalCars", carType: carType.marshal, isChecked: false },
    { carName: "bewrageCars", carType: carType.bevcart, isChecked: false },
    { carName: "specialNeedsCars", carType: carType.handicap, isChecked: true },
    { carName: "memberCars", carType: carType.member, isChecked: true },
    { carName: "notCommunicatingCars", carType: carType.notCommunicating, isChecked: false },
    { carName: "notInUseCars", carType: carType.notInUse, isChecked: false },
    { carName: "outsidePerimeterCars", carType: carType.outOfService, isChecked: false },
  ],
  historyOptions: 1,
  selectedHistoryOption: null,
  allCarsData: [],
  carInfoState: [],
  filteredCarsData: [],
  showTaggedCar: null,
  showTaggedCarArray: [],
  showTaggedCarArrayLength: 0,
  showTaggedGpsArray: [],
  showTaggedCarArrayClickToDrive: [],
  showTaggedCarArrayClickToDriveInputShower: false,
  showTaggedCarArrayClickToDriveInputValueSetter: [],
  gpsCardIdState: [],
  openInfoWindow: true,
  highlightTagCar: false,
  carHistoryList: [],
  allTaggedCars: [],
  centerPointLat: 0,
  centerPointLong: 0,
  sendMessage: false,
  showHoleMarkersState: false,
  messageZone: false,
  controlZone: false,
  cartpathZone: false,
  geofenceZone: false,
  cartPathPolygon: "",
  cartPathActionZone: false,
  geofenceActionZone: false,
  messageActionZone: false,
  controlsActionZone: false,
  specificCarHistory: false,
  specificCarTrackHistory: false,
  filterEnableDisable: [],
  filteredCarsList: [],
  showCarDetails: false,
  carForPopup: {},
  // Setting Part

  WeatherAlertGlobal: false,
  ScorecardGlobal: false,
  BlindShotGlobal: false,
  ShowNameSonwelComeScreenGlobal: false,
  ShowPlaysLikeYardageGlobal: false,
  HideDistancesGlobal: false,
  PrintScorecardGlobal: false,
  ShareScorecardGlobal: false,
  AutoplayFlyoversGlobal: false,
  ShowOverMaxHolesOnCartGlobal: false,
  Heatmap: false,

  DisableDistancesOnMaxHolesGlobal: false,
  BehindPaceWarningGlobal: false,
  PaceStatusTimeGlobal: false,

  //Pace
  paceLoading: false,

  //Action Zone Global State
  addActionZonePolygon: null,
  toggleAddActionZonePolygon: null,
  actionZoneIsCartPathOnly: false,
  isEnabledActionZone: true,
  deactiveAllAction: deactivateAllBtn,
  toggleDeactiveAllAction: null,
  fillPolygonColor: "#800080",
  openActionZoneWindow: false,
  openEditActionZOneWindow: false,
  editActionZonePolygonData: {},
  editActionZonePolygonVertices: [],
  previousEditedPolygon: null,
  loadingOnProcess: false,
  carDetailGpsiCarId: null,
  carNumberHover: false,
  courseExtents: [],
  overlay: null,
  heightMapToggle: null,
  callSiteSelection: false,
  AZCategoryClicked: false,
  AZDrawingCompleted: false,
  addingNewActionZone: false,
  siteListPopupOpen: false,
  callAllSiteFunction: false,
  historyNoDataPopup: false,
  polyclickEnd: true,
  actionZoneModified: false,
  editAzCssCursorToUse: null,
  editAzCssCursorLastUsed: null,
  isMouseOverPolygon: false,
  isDrawingNewPolygon: false,
  isMouseOverEdgeOrVertex: false, // Set to true during time a new polygon for an AZ is being drawn for the first time
  actionZoneId: 0,
  currentAzClickedOnEditId: 0,
  actionZoneButtonClicked: "",
  optionsCPOShowCourses: false,
  actionZoneAction: 0,
  cancelActionZoneEdit: false,
  actionZoneRequest: null,
  saveActionZone: false,
  deleteActionZone: null,
  actionZoneVertexCount: 0,
  cpoData: [],
  shouldInitCpoData: false,
  polygonSelectedForCpo: null,
  shouldCallCpoSelected: false,
  setCPOColor: {},
  shouldSetCpoColor: null,
  optionsCPOData: null,
  lastSelectedActionZoneImageId: null,
  refreshActionZones: null
});

const DATE_PICKER_PROPS = createState({
  startDateGlobalState: "",
  endDateGlobalState: "",
});

let alertPopupState = JSON.parse(localStorage.getItem("alertPopup"));
let alertBeepState = JSON.parse(localStorage.getItem("alertBeep"));

const FLEET_GLOBAL_STATES = createState({
  playerNameData1: "Player 1",
  playerNameData2: "Player 2",
  gpsCardIdStateData: null,
  closingPopup: false,
  firstAudible: false,
  firstPopup: false,
  fleetCarData: [],
  fleetCarLength: 0,
  stagingModeDataGlobalState: null,
  enableDisableLockdownState: false,
  enableDisablePeekChargingState: false,
  tagCarFromFleet: [],
  storeFleetTagCarData: [],
  toggleFleetCarList: 0,
  toggleAppInfo: false,
  toggleSimInfo: false,
  toggleFleetCarTableView: "false",
  allFleetCarsData: [],
  allSortedFleetCarsData: [],
  selectedFleetCarsData: [],
  toggleSelectedCars: false,
  toggleUnselectedCars: true,
  selectedCarList: [],
  selectedCarList2: [],
  carSettingsDataContainer: [],
  selectFleetCarsData: [],
  selectFleetCarsUpdatedData: [],
  selectFleetCarsData2: [],
  selectFleetCarsUpdatedData2: [],
  selectedCarListBackup: [],
  selectMaxHolesCarList: [],
  selectCarTypeCarList: [],
  selectedDistanceUnits: [],
  selectedDistancesEnabledCar: [],
  selectedGpsCarList: [],
  selectedSpeedCarList: [],
  setMsgToSingleCar: "",
  highlightedCarList: [],
  selectedCarInBox: [],
  fleetSettingGlobalState: false,
  fleetSettingColorGlobalState: false,
  weatherAlertPopUpDisplayer: false,
  weatherAlertGlobalState: false,
  scoreCardPrintGlobalState: false,
  fleetStartDateData: "",
  fleetEndDateData: "",
  historyStartDateData: "",
  historyEndDateData: "",
  showStagingPopup: "",
  setPopupData: false,
  callApiThroughPopUp: true,
  audibleAlertGlobal: alertBeepState,
  popUpAlertGlobal: alertPopupState,
  badgeCount: 0,
  roundStateGlobal: false,
  holeStateGlobal: true,
  lockState: false,
  setStagedCarsState: false,
  fleetCarNumbers: [],
  fleetCarNumbersInvert: []
});

const DISTANCE_PROPERTY_WINDOW_GLOBAL_STATES = createState({
  showDistance: [],
});
const GLOBAL_SITE_SEARCH = createState({
  siteSearchValue: "",
  isFirstUpdate: true,
});
const MESSAGE_FLEET_GLOBAL_STATES = createState({
  isLoading: false,
  forwardMessageGlobalState: false,
  messageBadgeCount: 0,
});

const MULTICAR_PROPERTY_WINDOW_GLOBAL_STATES = createState({
  isopen: false,
});

const SETTING_POPUP_PROPERTY_WINDOW_GLOBAL_STATES = createState({
  isdisable: "",
});

const LIST_BY_GLOBAL_STATES = createState({
  listBy: localStorage.getItem("ListBy")
    ? localStorage.getItem("ListBy")
    : "NONE",
  sortBy: localStorage.getItem("sortBy")
    ? localStorage.getItem("sortBy")
    : "car",
  modeBy: localStorage.getItem("mode")
    ? localStorage.getItem("mode")
    : "NORMAL",
  showFilterNotCommunicating: false,
  showFilterbattry: false,
  showFilterServices: false,
  memberCar: false,
  showFilterNotCommunicatingMessage: "",
  sortButton: true,
});

const MAX_HOLES_GLOBAL_STATE = createState({
  maxHolesAllowed: "No Limit",
  detectChangeMaxHolesAllowed: false,
});
const MESSAGE_BY_GLOBAL_STATES = createState({
  messageSideNavTabState: "",
  HandelSaveButton: [],
});
const NOTIFICATION_GLOBAL_STATES = createState({
  editButton: false,
  editButtonId: 0,
  notificatioEmail: "",
  notificationPlayer: false,
  notificationActionZone: false,
  notificationCarFault: false,
  notificationLowBattery: false,
  notificationMaxHoles: false,
  notificationFirstHoleStarted: false,
  watch: 0,
  notificatioAddEmailButton: false,
  notificationAlertSOS: false,
  alertEnable: false,
  disableCross: true,
  saveEnable: false,
});
const CARPROPERTYWINDOW_GLOBAL_STATES = createState({
  closeButton: false,
});

const DASHBOARD_GLOBAL_STATE = createState({
  resetModuleState: false,
  globalModalState: false,
});
const MESSAGES_GLOBAL_STATE = createState({
  messagesSideNavTabState: "",
});
const MESSAGE_VDU_GLOBAL_STATE = createState({
  globalMessageVDU: "",
  globalAlertMessageVDU: false,
  globalMessageBoxOpenClose: false,
  globalMessageText: "",
  globalMessagePriorityAlert: true,
  globalMessageResponse: true,
  globalMessageId: 0,
  globalAllCannedMessageData: {},
  globalMessageBoxOpenCloseTable: false,
  globalIndexVDU: -1,
  setSave: false,
});

const SITELOCATION_GLOBAL_STATE = createState({
  siteLocationGlobalData: false,
  singleSiteLocationData: false,
  dropDownEvent: false,
  recentSiteState: false,
});
const SITEID_GLOBAL_STATE = createState({
  siteId: localStorage.getItem("recentSite")
    ? localStorage.getItem("recentSite")
    : null,
  selectSite: false,
  hideSubNav: false,
  hasSiteChangedAds: null
});
const UPDATED_CAR_DATA_STATE = createState({
  updatedCarData: [],
});
const CHECKBOX_LOADER = createState({
  LoadingState: false,
  generalTabLoader: false,
  scoreCardTabLoader: false,
  roundManagementLoader: false,
  alertsLoader: false,
  FleetLockdownLoader: false,
  PeakCharginLoader: false,
  AdminandSupportLoader: false
});
const CAR_LOCATION_STATE = createState({
  CarLocationBtn: localStorage.getItem("CarLocationBtn")
    ? JSON.parse(localStorage.getItem("CarLocationBtn"))
    : false,
  locationData: {
    state: false,
    carType: null,
    carnumber: null,
    GpsiCarId: null,
  },
});

const TAGGED_CAR = createState({
  TagCar: null,
});

const SLIDER_STATE = createState({
  sliderState: [],
});

const ADS_GLOBAL_STATE = createState({
  editCampState: "",
  baseCamp: {},
  publishCampButtonState: false,
  redirectState: false,
  alertMsg: false,
  nextStageName: "",
  nextTabIndex: "",
  redirectModalstate: false,
  publishNowCount: 0,
  shouldShowPublishNow: false
});

const COP_GLOBAL_STATES = createState({
  openSaveChangesModal: false,
  carPathUnSavedChanges: false,
  nextSubTabIndex: "",
  nextSubTabName: "",
  nextMainTabIndex: "",
  nextMainTabName: "",
});

const ADMIN_GLOBAL_STATE = createState({
  countMatch: 0,
});

const SiteSetupAction = createState({
  showAreas: false,
  showCenterOfGreens: false,
  showTeeMarkers: false,
  showPointsOfInterest: false,
  teesBtn: true,
  gmsBtn: true,
  fwysBtn: true,
  extsBtn: true,
  stgsBtn: true,
  HolesData: null,
  showAll: true,
  hideAll: false,
  editSiteSetup: false,
  addSiteSetup: false,
  holeView: false,
  holeChange: false,
  holeSelected: null,
  courseNo: "",
  addSelectType: 1,
  typeHole: 1,
  holeNum: 1,
  imageUrl: "",
  imageHoleNo: "",
  showSiteData: false,
  poiSiteData: false,
  teeSiteData: false,
  areaModified: false,
  refreshSiteSetupAreas: false,
  isPreviewImageZoomed: false,
  isSaveSiteArea: null,
  isSaveHoleArea: null
});

const GlobalCourseIdState = createState({
  globalCourseId: localStorage.getItem("courseId")
    ? localStorage.getItem("courseId")
    : 1,
  resetGlobalCourseId: "1",
  setCourseId: localStorage.getItem("dashCourseId")
    ? localStorage.getItem("dashCourseId")
    : 1,
});
const PINS_GLOBAL_STATE = createState({
  showHideGridsGlobalHookState: false,
  showHidePinsGlobalHookState: false,
  dailyRotationHandler: false,
  localStorageTracker: false,
  setdisabledEditButton: false,
  setDisplayButton: false,
  refreshChecker: 0,
  showCourseModal: false,
  pinRerenderStopper: true,
  cogCheckerForDailyPins: false,
  cogCheckerForSpecialPins: false,
});
const ADMIN_SITE_SETTINGS = createState({
  selectedCustomerServiceProfile: null,
});

const FB_GLOBAL_STATES = createState({
  fbOrdersSettings:
    localStorage["fbOrdersSettings"] !== undefined
      ? JSON.parse(localStorage.getItem("fbOrdersSettings"))
      : {
          fillOrdersHere: false,
          beepOnNewOrder: true,
          beepWhileOrderPending: false,
          popupOnNewOrder: false,
          showCompleted: false,
          refreshInterval: 30,
        },

  foodOrdersCourseFilter:
    localStorage["fbOrdersCourseFilter"] !== undefined
      ? JSON.parse(localStorage.getItem("fbOrdersCourseFilter"))
      : {
          courseFilters: null,
        },

  pendingOrdersCount: 0,
  ordersNotificationState: false,
  ordersData: [],
  orderDataCounter: 0,
  foodOrderNotificationCount: 0,
});

const ADMIN_SITE_CONFIG = createState({
  isHoleDataModified: false,
  isTSModified: false,
});

const MAX_VOLUME_ALLOWED = createState({
  maxVolumeAllowed: "",
  maxVolumeOptionTriggered: false,
});

export {
  APP_CONSTANTS_STATE,
  ADS_GLOBAL_STATE,
  DATE_PICKER_PROPS,
  CARPROPERTYWINDOW_GLOBAL_STATES,
  SiteSetupAction,
  CAR_LOCATION_STATE,
  TAGGED_CAR,
  COMMON_COMPONENTS_STATES,
  DISTANCE_PROPERTY_WINDOW_GLOBAL_STATES,
  FLEET_GLOBAL_STATES,
  LIST_BY_GLOBAL_STATES,
  CAR_NUMBER_MESSAGE,
  MAP_GLOBAL_STATES,
  MESSAGE_COUNT,
  MESSAGE_BY_GLOBAL_STATES,
  MESSAGE_FLEET_GLOBAL_STATES,
  GLOBAL_SITE_SEARCH,
  MESSAGE_VDU_GLOBAL_STATE,
  MESSAGES_GLOBAL_STATE,
  MULTICAR_PROPERTY_WINDOW_GLOBAL_STATES,
  NOTIFICATION_GLOBAL_STATES,
  PINS_GLOBAL_STATE,
  SETTING_POPUP_PROPERTY_WINDOW_GLOBAL_STATES,
  SIDENAV_GLOBAL_STATE,
  SITEID_GLOBAL_STATE,
  SITELOCATION_GLOBAL_STATE,
  SLIDER_STATE,
  MAX_HOLES_GLOBAL_STATE,
  CHECKBOX_LOADER,
  GlobalCourseIdState,
  UPDATED_CAR_DATA_STATE,
  DASHBOARD_GLOBAL_STATE,
  ADMIN_SITE_SETTINGS,
  TAGGINGCAR,
  FB_GLOBAL_STATES,
  CHATMESSAGE,
  LANGUAGE_GLOBAL_STATE,
  MANIFEST_COUNT,
  ADMIN_SITE_CONFIG,
  ADMIN_GLOBAL_STATE,
  COP_GLOBAL_STATES,
  MAX_VOLUME_ALLOWED,
};
